import axios from 'axios';
import store from '../../Store/Store';
import { setError, setErrorMessage, setErrorStatus } from '../../Store/Actions/errorActions';

const requestClient = axios.create({
    timeout: 60000,
});

requestClient.interceptors.request.use((config) => {
    const { settings, userSettings, i18n } = store.getState();
    if (settings.apiBaseUrl) {
        config.baseURL = settings.apiBaseUrl;
    }
    if (i18n.selectedLanguage) {
        config.headers['UserLanguage'] = i18n.selectedLanguage;
    }
    config.headers['Provider'] = localStorage.getItem('loginProvider') ?? 'oidc';

    return config;
});

requestClient.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response ? error.response.status : 404;
        store.dispatch(setErrorStatus(status));
        switch (status) {
            case 403:
                if (!window.location.search.includes('retry=')) {
                    window.location.href = `${
                        store.getState().settings.apiBaseUrl
                    }/login?redirectUri=${encodeURIComponent(
                        window.location.href + (window.location.href.includes('?') ? '&' : '?') + 'retry=1',
                    )}`;
                } else {
                    store.dispatch(setError(true));
                }
                break;
            case 404:
                store.dispatch(setError(true));
                store.dispatch(setErrorMessage('404'));
                break;
            case 500:
                store.dispatch(setError(true));
                store.dispatch(setErrorMessage('500'));
                break;
            default:
                store.dispatch(setError(true));
                break;
        }
        return new Promise(() => {});
    },
);

export default requestClient;
